import { DatasetSpaceDetail } from "@/components/datasets/dataset-space-detail.tsx";
import { m } from "@/paraglide/messages.js";
import { spaceTablesQueryOptions } from "@/services/datasets-service.ts";
import { spaceQueryOptions } from "@/services/spaces-service.ts";
import { createEntityErrorBoundary } from "@/utils/entity-error-boundary.tsx";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { datasetTab } from "@/components/datasets/dataset-tabs.ts";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

const searchSchema = z.object({
	// The currently-selected table (by name) within the space, if any.
	table: z.string().optional(),
	// #1461: deep-link support — land on a specific tab (create_dashboard's
	// returned path opens the Dashboards tab directly)…
	tab: datasetTab.optional(),
	// …and preselect a specific dashboard artifact in that tab.
	dashboard: z.uuid().optional(),
});

export const Route = createFileRoute(
	"/_authenticated/dashboard/datasets/$spaceId",
)({
	validateSearch: searchSchema,
	loader: async ({ params, context: { queryClient } }) => {
		// Validate here (not in params.parse) so a malformed id throws inside the
		// loader, where the route's errorComponent catches it — param-parse throws
		// happen during matching and escape to the global boundary instead.
		z.uuid().parse(params.spaceId);
		queryClient.prefetchQuery(spaceTablesQueryOptions(params.spaceId));
		await queryClient.ensureQueryData(spaceQueryOptions(params.spaceId));
	},
	errorComponent: createEntityErrorBoundary({
		title: m.dataset_not_found_title,
		description: m.dataset_not_found_description,
		backLabel: m.dataset_not_found_back,
		backTo: "/dashboard/datasets",
	}),
	head: () => ({
		meta: [{ title: pageTitle(m.datasets_space_title()) }],
	}),
	component: DatasetSpaceDetail,
	pendingComponent: RoutePending,
});
